<template>
  <div :class="['group list-input', { empty: !terminals.length }]">
    <!-- Controls -->
    <div class="list-input-controls">
      <span class="text-muted small">{{
        terminals.length ? "TERMINALS" : "ADD A NEW TERMINAL"
      }}</span>
      <b-button
        variant="light"
        class="list-input-btn"
        v-b-tooltip.hover.right="'Add a new terminal'"
        @click="add()"
      >
        <font-awesome-icon :icon="['fas', 'plus']" />
      </b-button>
    </div>

    <!-- Terminals -->
    <div v-for="(terminal, i) in terminals" :key="i" class="list-input-item">
      <b-form-group label="Type">
        <b-form-select v-model="terminal.terminalType" :options="terminalTypeOptions" />
      </b-form-group>

      <b-form-group label="Charge">
        <b-form-input v-model="terminal.terminalCharge" type="number" min="0" />
      </b-form-group>

      <b-form-group label="Model">
        <b-form-input v-model="terminal.terminalModel" />
      </b-form-group>

      <b-dropdown
        variant="link"
        toggle-class="text-decoration-none p-0"
        no-caret
        boundary="viewport"
      >
        <template #button-content>
          <font-awesome-icon :icon="['fas', 'bars']" />
        </template>
        <b-dropdown-item @click="add(terminal)">Duplicate</b-dropdown-item>
        <b-dropdown-item @click="remove(i)" variant="danger"><font-awesome-icon class="mr-1"  :icon="['fal', 'trash-alt']" /> Remove </b-dropdown-item>
      </b-dropdown>

      <hr v-if="i != terminals.length - 1" class="divider" />
    </div>
  </div>
</template>

<script>
export default {
  name: "TerminalsInput",
  model: {
    prop: "terminals",
    event: "change"
  },
  props: {
    terminals: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      terminalTypeOptions: ["Desktop", "Portable", "Mobile", "Unknown"]
    };
  },
  methods: {
    onChange() {
      this.$emit("change", this.terminals);
    },

    add(terminal) {
      if (!terminal) {
        terminal = {
          terminalType: null,
          terminalCharge: null,
          terminalModel: null
        };
      } else {
        // Create a new object, we don't want a reference
        terminal = Object.assign({}, terminal);
      }
      this.terminals.push(terminal);
      this.onChange();
    },

    remove(index) {
      this.$delete(this.terminals, index);
      this.onChange();
    }
  }
};
</script>
<style lang="scss" scoped>
.list-input.empty {
  max-width: 13.5rem;
}
</style>